import { render, staticRenderFns } from "./EmployerCard.vue?vue&type=template&id=31c18387&scoped=true"
import script from "./EmployerCard.vue?vue&type=script&lang=ts"
export * from "./EmployerCard.vue?vue&type=script&lang=ts"
import style0 from "./EmployerCard.vue?vue&type=style&index=0&id=31c18387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c18387",
  null
  
)

export default component.exports